export const TIPONOTIFICACAO = {
    IMPORTACAO_DE_PLANILHA: 1
}
